import { useState } from "react";

import {
    Column,
    Icon,
    MediaStack,
    Row,
    TagWrapper,
    Text,
    TextButton,
    TextExternalLink,
    useAppPalette
} from "@bridgesplit/ui";
import { useAuthStorage } from "@bridgesplit/abf-react";
import { ALLOWED_FEATURES } from "@bridgesplit/utils";

import { DESKTOP_PADDING, MOBILE_PADDING, NAV_BREAKPOINT, useNavbarHeight } from "../navbar";

export default function AppAlertBanner() {
    const { height } = useNavbarHeight();
    const { background } = useAppPalette();

    const { state } = useAuthStorage();

    if (ALLOWED_FEATURES.appExploitBanner) {
        return <AppNotificationBanner />;
    }
    if (!state.apiVersionUpdateNeeded) return null;

    return (
        <Column sx={{ mt: height + "px", mb: -height + "px", background }}>
            <TagWrapper sx={{ px: DESKTOP_PADDING, [NAV_BREAKPOINT.below]: { px: MOBILE_PADDING } }} color="error">
                <MediaStack spacing={1}>
                    <Text svgColor="error" variant="h4">
                        <Icon type="warning" /> Update available
                    </Text>
                    <Text color="caption">
                        Please refresh the page at your convenience to ensure everything works smoothly
                    </Text>
                    <TextButton onClick={() => window.location.reload()} underlineLink>
                        Refresh now
                    </TextButton>
                </MediaStack>
            </TagWrapper>
        </Column>
    );
}

// Used for when withdrawls go live.
export function AppNotificationBanner() {
    const { height } = useNavbarHeight();
    const { background } = useAppPalette();
    const [showBanner, setShowBanner] = useState(true);

    if (!showBanner) return null;

    return (
        <Column sx={{ mt: height + "px", mb: -height + "px", background }}>
            <TagWrapper
                sx={{
                    px: DESKTOP_PADDING,
                    [NAV_BREAKPOINT.below]: { px: MOBILE_PADDING }
                }}
                color="info"
            >
                <Row spaceBetween>
                    <MediaStack spacing={1}>
                        <Text svgColor="info" variant="h4">
                            <Icon type="warning" />
                        </Text>

                        <Text color="caption">Vault deposits and borrow actions are temporarily paused</Text>
                        <TextExternalLink href="https://x.com/LoopscaleLabs/status/1920182230762336342">
                            Learn more
                        </TextExternalLink>
                    </MediaStack>
                    <TextButton onClick={() => setShowBanner(false)}>
                        <Icon type="reject" />
                    </TextButton>
                </Row>
            </TagWrapper>
        </Column>
    );
}
